export default class CampaignFreeShipModel {
    constructor() {
        this.campaignId = 0;
        this.minimumOrderValue = 0;
        this.maximumDiscount = 0;
    }
}
